"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopApplication = void 0;
var PopApplication;
(function (PopApplication) {
    PopApplication["BIOLOGY_PROD_IOS"] = "BIOLOGY_PROD_IOS";
    PopApplication["CHEMISTRY_PROD_IOS"] = "CHEMISTRY_PROD_IOS";
    PopApplication["FRENCH_PROD_IOS"] = "FRENCH_PROD_IOS";
    PopApplication["LT_DEV_IOS"] = "LT_DEV_IOS";
    PopApplication["LT_PROD_IOS"] = "LT_PROD_IOS";
    PopApplication["LT_DEV_WEB"] = "LT_DEV_WEB";
    PopApplication["LT_PROD_WEB"] = "LT_PROD_WEB";
    PopApplication["QUIZ_PROD_WEB"] = "QUIZ_PROD_WEB";
})(PopApplication = exports.PopApplication || (exports.PopApplication = {}));
